var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0339 14.8739C9.6734 14.6722 9.234 14.6722 8.87353 14.8739L5.32796 16.8586C4.44355 17.3537 3.38529 16.5848 3.58278 15.5907L4.37455 11.6052C4.45505 11.2001 4.31925 10.7822 4.01595 10.5017L1.03231 7.74278C0.288133 7.05465 0.692307 5.81056 1.69883 5.69118L5.73413 5.2126C6.14431 5.16395 6.49977 4.9057 6.67279 4.53063L8.37515 0.840344C8.7997 -0.0799702 10.1077 -0.0799685 10.5322 0.840346L12.2346 4.53063C12.4076 4.9057 12.7631 5.16395 13.1733 5.2126L17.2086 5.69118C18.2151 5.81056 18.6193 7.05465 17.8751 7.74278L14.8915 10.5017C14.5882 10.7822 14.4523 11.2001 14.5328 11.6052L15.3246 15.5907C15.5221 16.5848 14.4639 17.3537 13.5794 16.8586L10.0339 14.8739Z",
    fill: "#EAAC0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSolid);
export default __webpack_public_path__ + "static/media/star_solid.b3580d8ca554b54b1b3407a096dd070d.svg";
export { ForwardRef as ReactComponent };